import React, { useState } from "react";
import "./PhoneNumberInput.css";
import PhoneInput, { CountryData } from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

interface PhoneNumberInputProps {
  value?: string;
  onChange: (value: string, data: CountryData) => void;
  error?: string;
  className?: string;
  touched?: boolean;
}

// Max length mapping for countries (without country code)
const countryMaxLength: Record<string, number> = {
  us: 12,
  ca: 12,
  in: 13,
  gb: 12,
  lk: 12,
  au: 12,
  nz: 12,
  de: 13,
  fr: 13,
  it: 13,
  es: 12,
  jp: 13,
  cn: 13,
  br: 13,
  mx: 13,
  ru: 13,
  za: 12,
  ng: 13,
  ke: 12,
};

export const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  value,
  onChange,
  error,
  touched,
}) => {
  const [countryCode, setCountryCode] = useState("us");

  const handleChange = (phone: string, data: CountryData) => {
    setCountryCode(data.countryCode);

    const dialCodeLength = data.dialCode.length;
    // Get only the user-entered digits
    let digitsOnly = phone.replace(/\D/g, "").slice(dialCodeLength);

    const maxLength = countryMaxLength[data.countryCode] || 15;

    if (digitsOnly.length > maxLength) {
      digitsOnly = digitsOnly.slice(0, maxLength); // trim extra digits
    }

    const finalPhone = `+${data.dialCode}${digitsOnly}`;
    onChange(finalPhone, data);
  };

  // Compute maxLength for input field dynamically
  const maxLength =
    (countryMaxLength[countryCode] || 15) +
    (countryCode ? countryCode.length + 1 : 0); // +1 for '+'

  return (
    <div className="phone-input-container">
      <div className="phone-input-wrapper" style={{ position: "relative" }}>
        <PhoneInput
          country={countryCode}
          value={value}
          onChange={handleChange}
          inputClass="phone-input"
          buttonClass="country-select"
          dropdownClass="country-dropdown"
          containerClass="phone-container"
          disableDropdown={false}
          inputProps={{
            maxLength: maxLength, // limit input field characters
          }}
        />
      </div>
      {error && touched && <div className="error">{error}</div>}
    </div>
  );
};
